import {Component, OnInit, OnDestroy, ViewChild, ElementRef} from '@angular/core';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';


import {Column, GridOption, AngularGridInstance, Formatters} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Subscription} from 'rxjs';
import * as d3 from 'd3';
import * as _ from 'lodash';

import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

// import { legendColor,legendSize } from 'd3-svg-legend';

@Component({
    selector: 'app-dashboard-report-heatmap',
    templateUrl: './dashboard-report-heatmap.component.html',
    styleUrls: ['./dashboard-report-heatmap.component.css']
})
export class DashboardReportHeatmapComponent implements OnInit {
    @ViewChild('heatMap')
    private heatMapContainer: ElementRef;

    @ViewChild('reportBody')
    private reportBody: ElementRef;


    respObject: any;
    private clientId: number;
    private notifier: NotifierService;

    reportTypeArray = [];
    ticketTypeArray = [];

    lastXmonth: number;
    maxSla: number;

    selectedReportType: number;
    selectedTicketType: number;

    reportTypeTitle: string;
    reportFilterTitle: string;
    viewReport: boolean;
    dataLoaded: boolean;
    viewTicketType: boolean;

    reportHeadMapData = [];

    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
                private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
    }

    ngOnInit() {

        this._rest.getUserdetails(this.messageService.getUserId()).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.clientId = this.respObject.details[0].clientId;
                //this.getSLAComplainceReport();
                this.getTicketType();
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });

        this.reportTypeArray = [{type: 0, view: 'Select Report Type'},
            {type: 1, view: 'Overall'},
            {type: 2, view: 'Support group'},
            {type: 3, view: 'Category'},
            {type: 4, view: 'Ticket type'},
        ];

        this.viewReport = false;
        this.dataLoaded = true;
        this.reportFilterTitle = '';
        //this.lastXmonth = 0;
        //this.maxSla = 0;
        this.selectedReportType = 0;
        this.selectedTicketType = 0;
        this.viewTicketType = false;

    }

    onTicketTypeChange(value: any) {

    }

    getTicketType() {
        this._rest.getTicketType(this.clientId).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
                this.ticketTypeArray = this.respObject.details;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    onReportTypeChange(value: any) {
        if (value === 3) {
            this.viewTicketType = true;
        } else {
            this.viewTicketType = false;
        }
    }

    generateDashboardReport() {

        if (this.selectedReportType === 0) {
            this.notifier.notify('error', 'Please select a type.');
            return;
        }

        if (!this.lastXmonth) {
            this.notifier.notify('error', 'Please enter last month range.');
            return;
        }
        if (!this.maxSla) {
            this.notifier.notify('error', 'Please enter maximum SLA Compliance.');
            return;
        }

        if (this.selectedReportType === 3 && this.selectedTicketType === 0) {
            this.notifier.notify('error', 'Please select a ticket type');
            return;
        }


        this.viewReport = false;
        this.dataLoaded = false;
        this._rest.getHeatmapReport(this.clientId, this.selectedReportType, this.lastXmonth, this.maxSla, this.selectedTicketType).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.dataLoaded = true;
                this.viewReport = true;
                this.reportTypeTitle = this.reportTypeArray[this.selectedReportType].view;
                this.reportHeadMapData = this.respObject.details;
                this.createHeatMap(this.reportHeadMapData);

            } else {
                this.viewReport = false;
                this.dataLoaded = true;
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.viewReport = false;
            this.dataLoaded = true;
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    daysInMonth(month, year) {
        return new Date(year, month, 0).getDate();
    }


    createHeatMap(data) {

        console.log('Heat Map Array --- ');
        console.log(data);
        const element = this.heatMapContainer.nativeElement;
        let dwidth = element.parentElement.parentElement.offsetWidth - 60;

        const margin = {top: 300, right: 50, bottom: 50, left: 150};

        let width = dwidth - margin.left - margin.right,
            height = 500 - margin.top - margin.bottom;


        d3.select(element).select('svg').remove();

        const svg = d3.select(element).append('svg')
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

        const formattedData = this.formatData(data);
        console.log(formattedData);
        const extent = ['0', this.maxSla];

        // Create colour scale
        let colourScale = d3.scaleLinear();

        colourScale.range(['#ffe6e6', '#ff0000']);
        colourScale.domain([extent[1], extent[0]]);

        this.drawHeatMap(svg, height, width, formattedData, {
            height: height,
            width: width,
            xLength: formattedData[0].typeResults.length,
            rowLabelXPadding: 10,
            columnLabelYPadding: 10
        }, colourScale);
    }

    formatData(data) {
        let times = [];
        data.forEach(d => {
            let typeArray = [];
            for (let type in d) {
                if (type != 'Date') {
                    typeArray.push({
                        type: type,
                        percentage: d[type]
                    });
                }
            }
            times.push({
                typeResults: typeArray,
                timeClass: d['Date']
            });
        });
        return times;
    }

    // Refactor and pass position of label via config
    showLabel(d) {
        var coords = [d3.event.clientX, d3.event.clientY];
        var top = coords[1] + 30,
            left = coords[0] - 50;

        d3.select('.tooltip')
            .style('top', top + 'px')
            .style('left', left + 'px')
            .transition()
            .duration(200)
            .style('opacity', 1);

        d3.select('.tooltip')
            .html(d.percentage + '%');

    }

    moveLabel() {
        const coords = [d3.event.clientX, d3.event.clientY];

        const top = coords[1] + 30,
            left = coords[0] - 50;

        d3.select('.tooltip')
            .style('top', top + 'px')
            .style('left', left + 'px');
    }

    hideLabel(d) {
        d3.select('.tooltip')
            .transition()
            .duration(200)
            .style('opacity', 0);
    }

    drawHeatMap(svg, height, width, data, config, colourScale) {
        const rectWidth = config.width / config.xLength,
            rectHeight = config.height / data.length;
        console.log('drawHeatMap');
        const rowGroups = svg.selectAll('g')
            .data(data).enter()
            .append('g')
            .attr('class', 'row-group')
            .attr('transform', (d, i) => 'translate(' + [0, i * rectHeight] + ')');

        const rects = rowGroups.selectAll('rect')
            .data(d => d.typeResults).enter()
            .append('rect')
            .attr('class', 'row')
            .attr('width', rectWidth)
            .attr('height', rectHeight)
            .attr('x', (d, i) => i * rectWidth)
            .style('fill', d => colourScale(d.percentage))
            .style('stroke', 'white')
            .style('stroke-width', '1px')
            .on('mouseover', this.showLabel)
            .on('mousemove', this.moveLabel)
            .on('mouseout', this.hideLabel);

        var percentageText = rowGroups.selectAll('text')
            .data(d => d.typeResults).enter()
            .append('text').text((d, i) => d.percentage + '%')
            .attr('x', (d, i) => i * rectWidth + (rectWidth / 2))
            .attr('y', rectHeight / 2)
            .attr('fill', '#000000')
            .style('text-anchor', 'middle')
            .style('dominant-baseline', 'central')
            .style('font-size', '12px');


        // Refactor
        const rowLabels = rowGroups.append('text')
            .attr('x', -config.rowLabelXPadding)
            .attr('y', rectHeight / 1.5)
            .attr('text-anchor', 'end')
            .text(d => d.timeClass);

        // Refactor
        // const columnLabels = svg.append("g")
        //   .attr("class", "columnLabels")
        //   .selectAll("text")
        //   .data(data[0].typeResults).enter()
        //   .append("text")
        //     .attr("text-anchor", "middle")
        //     .attr("x", (d, i) => i * rectWidth + (rectWidth / 2))
        //     .attr("y", -config.columnLabelYPadding)
        //     .text(d => d.type);

        var columnLabels = svg.append('g')
            .attr('class', 'columnLabels')
            .selectAll('text')
            .data(data[0].typeResults).enter()
            .append('text')
            .style('text-anchor', 'begin')
            .text(function (d) {
                return d.type;
            })
            .attr('y', function (d, i) {
                return i * rectWidth + (rectWidth / 2);
            })
            .attr('x', 10)
            .attr('transform', function (d) {
                return 'rotate(-90)';
            });

        const div = d3.select('body').append('div')
            .attr('class', 'tooltip')
            .style('opacity', 0);

        //  const legend = svg.append("g")
        //    .attr("class", "legend")
        //    .attr("transform", "translate(" + [0, height + rectHeight] + ")")

        //   const legendLinear = d3.legendColor()
        //     .shapeWidth(rectWidth)
        //     .shapeHeight(20)
        //     .shapePadding(0)
        //     .orient('horizontal')
        //     .scale(colourScale)
        //     .labelFormat(d => Math.round(d) + "%");

        //   legend.call(legendLinear);
    }

    exportAsPDF() {
        this.dataLoaded = false;
        const elementReport = this.reportBody.nativeElement;
        let reportTitle = 'Prescriptive Model - ' + this.reportTypeTitle + ' wise';
        let fileName = this.reportTypeTitle + ' wise Prescriptive Model.pdf';

        html2canvas(elementReport, {
            scale: 2
        }).then(canvas => {
            const imgWidth = 208;
            const pageHeight = 295;
            const imgHeight = canvas.height * imgWidth / canvas.width;
            const heightLeft = imgHeight;

            const contentDataURL = canvas.toDataURL('image/png');
            let pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF
            pdf.setFont('helvetica');
            pdf.setFontType('bold');
            pdf.setFontSize(9);
            pdf.text(reportTitle, 10, 10);
            pdf.addImage(contentDataURL, 'PNG', 0, 20, imgWidth, imgHeight);
            pdf.save(fileName); // Generated PDF
            this.dataLoaded = true;
        });


    }

    onResize(e) {
        this.createHeatMap(this.reportHeadMapData);
    }

}
